<template>
    <transition  >
    <div class="container-fluid ">
        <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Today's Bill </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Today's Bill List</a></li>
                                
                            </ol>
                        </div>
                        <div class="page-title-right float-right "> 
                            <!-- <button type="button" class="btn btn-success float-right" style="margin-left: 7px;" @click="toggleImportModal">
                                <i class="fas fa-plus"></i> Bulk Add Patient
                            </button>-->
                            <a href="/diagnosis-billings" class="btn btn-primary float-right">
                              Add New
                            </a>
                        </div>
                    </div>
                </div>
            </div>  
            <div class="row">
                <div class="col-12">
                    <!-- Search and export area -->
                    <div class="card">
                        <div class="card-header">
                            <h3 style="text-align: center;">Today's Bill List</h3>
                        </div>

                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <!-- <div class="">
                                        <label for="from_date"> From </label>
                                        <input type="date" class="form-control" id="from_date" v-model="tableData.from_date" @change="onkeyPress('from_date')">
                                        <div class="invalid-feedback" v-if="errors.from_date">
                                            {{errors.from_date[0]}}
                                        </div>
                                    </div> -->
                                </div>

                                <div class="col-md-3">
                                    <!-- <div class="">
                                        <label for="to_date"> To </label>
                                        <input type="date" class="form-control" id="to_date" v-model="tableData.to_date" @change="onkeyPress('to_date')">
                                        <div class="invalid-feedback" v-if="errors.to_date">
                                            {{errors.to_date[0]}}
                                        </div>
                                    </div> -->
                                </div>

                                <div class="col-md-3 ">
                                    
                                </div>

                                <div class="col-md-3">
                                    <div class="mt-3" style="text-align: right;">
                                        <!-- <button type="submit" class="btn-sm btn btn-primary" :disabled="disabled" @click="filterSalesReport()">
                                            <span v-show="isSubmit">
                                                <i class="fas fa-spinner fa-spin" ></i>
                                            </span>Submit 
                                        </button> -->
                                        <a href="javascript:void(0);" style="margin-left: 5px;" class="btn-sm btn btn-primary" @click.prevent="printAppointmentList()" ><i class="mdi mdi-printer-outline me-1"></i> </a>
                                        <!-- <a href="javascript:void(0);" style="margin-left: 5px;" class="btn-sm btn btn-primary"
                                        @click.prevent="downloading ? null : exportToExcel()">
                                            <span v-show="downloading"  >
                                                <i class="fas fa-spinner fa-spin"></i>
                                            </span> 
                                            <i class="mdi mdi-file-excel me-1"></i> 
                                        </a> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Content Area -->
                    <div class="card">
                        <div class="card-body">   
                            <Datatable 
                                :columns="columns" 
                                :sortKey="tableData.sortKey"  
                                @sort="sortBy" 
                                v-if="!loading">
                                <template #header > 
                                    <div class="tableFilters" style="margin-bottom: 10px;">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="control" style="float: left;">
                                                    <span style="float: left; margin-right: 10px; padding: 7px 0px;">Show </span>
                                                    <div class="select" style="float: left;">
                                                        <select class="form-select" v-model="tableData.length" @change="getBillingList()"> 
                                                            <option value="10" selected="selected">10</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="500">500</option>
                                                            <option :value="pagination.total">All</option>
                                                        </select>
                                                    </div>
                                                    <span style="float: left; margin-left: 10px; padding: 7px 0px;"> Entries</span>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-2">
                                                
                                            </div>
                                            <div class="col-md-4">
                                                <input type="text" class="form-control" style="float: right;" v-model="tableData.search" placeholder="Search..." @input="getBillingList()">
                                            </div>
                                        </div>
                                    </div>   
                                </template> 
                                <template #body >                            
                                    <tbody v-if="billing_items.length > 0">
                                        <tr class=" " v-for="(item, i) in billing_items" :key="i">
                                            <td>{{ i + 1 }} </td> 
                                            <td>{{ item.bill_date }}</td>
                                            <td>{{ item.bill_no }} </td> 
                                            <td>{{ item.patient_name }} </td> 
                                            <td>{{ item.patient_phone }} </td>
                                            <td>{{ item.payable_amount }}</td>
                                            <td>{{ item.paid_amount }}</td>
                                            <td style="text-align: center;">
                                                <span class="badge bg-success" v-if="item.payment_status == '2'"> PAID </span>
                                                <span class="badge bg-danger" v-else> DUE </span>
                                            </td>
                                            <td>
                                                <span class="badge bg-warning" v-if="item.status == '1'"> Pending </span>
                                                <span class="badge bg-info" v-else-if="item.status == '2'"> In Progress </span>
                                                <span class="badge bg-info" v-else-if="item.status == '3'"> Processing </span>
                                                <span class="badge bg-primary" v-else-if="item.status == '4'"> Process Completed </span>
                                                <span class="badge bg-primary" v-else-if="item.status == '5'"> Receiving Report </span>
                                                <span class="badge bg-dark" v-else-if="item.status == '6'"> Report Received </span>
                                                <span class="badge bg-success" v-else-if="item.status == '7'"> Delivered & Completed </span>
                                                <span class="badge bg-danger" v-else> Draft </span>
                                            </td>
                                            <td>
                                                <div class="action-btns text-center">
                                                    <!-- item-->
                                                    <!-- <a v-if="item.payment_status != 2" :href="getPaymentReceive(item)" target="_blank" class="btn btn-sm btn-primary" title="Payment Receive">
                                                        <i class="mdi mdi-currency-usd"></i>
                                                    </a>  -->
                                                    <a v-if="item.status==1" href="javascript:void(0);" @click="sendSampleCollection(item)" class="btn btn-sm btn-primary" title="Send To Sample Collection">
                                                        <i class="mdi mdi-arrow-right"></i>
                                                    </a> 
                                                    <a href="javascript:void(0);" @click="show(item)" class="btn btn-sm btn-info" title="Billing Details">
                                                        <i class="mdi mdi-eye-outline"></i>
                                                    </a> 
                                                    <a v-if="item.status < 4" :href="edit(item.id)" class="btn btn-sm btn-warning" title="Edit">
                                                        <i class="mdi mdi-circle-edit-outline"></i>
                                                    </a>
                                                    <a v-if="item.status < 3" href="javascript:void(0);" class="btn btn-sm btn-danger" @click="deleteItem(item)" title="Delete">
                                                        <i class="mdi mdi-delete-outline"></i>
                                                    </a>
                                                    <!-- item-->
                                                </div>  
                                            </td>
                                        </tr>
                                    </tbody> 
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="8"> No Data Available Here!</td>
                                        </tr>
                                    </tbody>
                                </template> 
                                <template #footer>
                                    <Pagination 
                                        :pagination="pagination"  
                                        :language="lang"
                                        @onChangePage="setPage" > 
                                    </Pagination> 
                                </template> 
                            </Datatable>


                            <div class="tab-pane show active" v-if="loading">
                                <div class="row"> 
                                    <div class="col-md-5">  
                                    </div>
                                    <div class=" col-md-2"> 
                                        <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                    </div>
                                    <div class="col-md-5">  
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div> 

            <!-- Modal -->
            <Modal @close="toggleModal()" :modalActive="modalActive">
                <div class="modal-content scrollbar-width-thin">
                    <div class="modal-header"> 
                        <h3>New Appointment</h3>
                        <button @click="toggleModal()" type="button" class="btn btn-sm btn-danger"> <i class="mdi mdi-close-outline"></i></button>
                    </div>
                    <div class="modal-body">
                        
                    </div>
                    <div class="modal-footer"> 
                        <button type="button" class="btn btn-danger" @click="toggleModal()">
                            Close
                        </button> 
                        <!-- <button type="submit" class="btn btn-primary " :disabled="disabled">
                            <span v-show="isSubmit">
                                <i class="fas fa-spinner fa-spin" ></i>
                            </span>{{btn}} 
                        </button>  -->
                    </div>
                </div>
            </Modal>

            <!-- View and Print Modal  -->
            <Modal @close="invoiceModal()" :modalActive="showModalActive">
                <div class="modal-content scrollbar-width-thin invoice-modal">
                    <div class="modal-header">
                    <h5>Invoice</h5>
                    <button @click="invoiceModal()" type="button" class="btn btn-default">
                        X
                    </button>
                    </div>
                    <div class="modal-body inv-perview">
                        <div id="billing-invoice" class="invoice-billing" v-if="billing_info != ''">
                            <div id="top">
                                <div class="row">
                                    <h2 class="text-center" style="font-size: 18px">{{this.retailShopName}}</h2>
                                    <h5 class="text-center" style="font-size: 14px"> {{ this.retailSmallText }}</h5>
                                    <p class="text-center cmb-5">
                                        {{ this.retailShopAddress }}
                                        <span v-if="invHeadPhone"> <br> Mobile: {{ this.invHeadPhone }} </span>
                                    </p> 
                                    <p class="text-center" ><strong> INVOICE </strong></p> 
                                </div>
                            </div>
                            <!--End InvoiceTop-->
                            <div id="mid">
                                <div class="info">
                                    <table style="width: 100%;">
                                        <tr>
                                            <td>ID No</td>
                                            <td>:</td>
                                            <td>{{ billing_info.bill_no }}</td>
                                            <td>
                                                <BarcodeGenerator
                                                    :value="billing_info.bill_no"
                                                    :format="'CODE128'"
                                                    :lineColor="'black'"
                                                    :height="22"
                                                    :width="1"
                                                    :elementTag="'img'"
                                                    :textPosition="19"
                                                    :fontSize="15"
                                                    :displayValue="false"
                                                    v-if="renderBarcodeComponent"
                                                />
                                            </td>
                                            <td style="text-align: right;">Date: {{ billing_info.bill_date }}</td>
                                        </tr>
                                        <tr>
                                            <td>Name</td>
                                            <td>:</td>
                                            <td id="pname">{{ billing_info.patient_name }}</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>Age</td>
                                            <td>:</td>
                                            <td>{{ billing_info.patient_age }}</td>
                                            <td style="text-align: right;"><span>Gender: {{ billing_info.patient_gender }}</span></td>
                                            <td style="text-align: right;"><span>M: {{ billing_info.patient_phone }}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Refd By</td>
                                            <td>:</td>
                                            <td colspan="3">{{ billing_info.reference_person_name }}</td>
                                        </tr>
                                    </table>
                                </div>
                            
                            </div>
                            <!--End Invoice Mid-->
                            <div id="bot">
                                <div class="items-info">
                                    <table style="width: 100% !important;">
                                        <thead>
                                            <tr>
                                                <td>SL</td>
                                                <td>Test/Service</td>
                                                <td>Qty</td>
                                                <td>Amount</td>
                                                <td>Disc%</td>
                                                <td style="text-align: right">Delivery Date/Time</td>
                                            </tr>
                                        </thead>

                                        <tbody v-if="billing_info.test_items.length > 0">
                                            <tr v-for="(item, i) in billing_info.test_items" :key="i">
                                                <td>{{ i+1 }}</td>
                                                <td>{{ item.diagnosis_tests.name }}</td>
                                                <td> {{ item.quantity }} </td>
                                                <td style="text-align: right"> {{ Number(item.price).toFixed(2) }} </td>
                                                <td style="text-align: right"> {{ item.discount }} </td>
                                                <td style="text-align: right"> {{ item.delivery_datetime }} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!--End Table-->
                                </div>

                                <!-- Payment Info and Others-->
                                <div class="corporate-payment-info">
                                    <div class="row">
                                        <div class="col-md-7 col-xs-7">
                                            <div class="row">
                                                <div class="col-md-6 col-xs-6">
                                                    <div class="corporate-info" v-if="billing_info.corporate_discount_status == 1">
                                                        <p style="margin: 0;">CORPORATE: </p>
                                                        <p>
                                                            {{ billing_info.corporate_company_name }} <br>
                                                            {{ 'Employee ID - ' + billing_info.corporate_employee_id }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-xs-6"></div>
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-xs-5">
                                            <table class="payment-info" style="width: 100%; text-align: right;">
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Total Amount</td>
                                                    <td>{{ Number(billing_info.total_amount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Discount ({{ (billing_info.discount_percent - billing_info.extra_discount_percent) }}%)</td>
                                                    <td>
                                                        {{ Number(billing_info.general_discount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}}
                                                    </td>
                                                </tr>
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Extra Discount ({{  billing_info.extra_discount_percent - 0 }}%)</td>
                                                    <td>
                                                        {{ Number(billing_info.extra_discount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}
                                                    </td>
                                                </tr>
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Payable </td>
                                                    <td>{{ Number(billing_info.payable_amount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}</td>
                                                </tr>                                                       
                                                <tr>
                                                    <td>Received Amount </td>
                                                    <td>
                                                        {{ Number(billing_info.paid_amount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}
                                                    </td>
                                                </tr>                                                
                                                <tr style="border-top: 1px solid #282828;">
                                                    <td>Due Amount </td>
                                                    <td>
                                                        {{ Number(billing_info.payable_amount - billing_info.paid_amount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>                                            
                                </div>

                                <div class="fixed-div">
                                    <div class="status-signatures">
                                        <div class="row">
                                            <div class="col-md-8 col-xs-8">
                                                <div class="status-info">
                                                    <h3 v-if="(billing_info.payable_amount) == billing_info.paid_amount">
                                                        <span style="">PAID</span>
                                                    </h3> 
                                                    <h3 v-else>
                                                        <span>DUE</span>
                                                    </h3> 
                                                    <span style="font-size: 11px;">Printed on {{ new Date().toLocaleDateString() }} {{ new Date().toLocaleTimeString() }}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-xs-4">
                                                <div class="signature-info">
                                                    <h4>{{ billing_info.created_users.name }}</h4>
                                                    <span>(Signature)</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="room-info">
                                        <p> 
                                            যে সকল রুমে যাবেন: 
                                            <span v-for="(item, r) in JSON.parse(billing_info.room_numbers)" :key="r">{{  item }}</span>
                                        </p>
                                    </div>
                                    
                                    <div class="legal-info">
                                        <h6>
                                            সকল তথ্য ও সিরিয়াল এর জন্য হটলাইনঃ {{ this.invHeadPhone }}
                                        </h6>
                                        <h6>
                                            বিঃদ্রঃ মূল রিসিট ছাড়া কোন রিপোর্ট ডেলিভারি হয় না ।
                                        </h6>
                                        <h6>
                                            রিপোর্ট ডেলিভারী নিচ তলায় রিসিপশন সকাল ৯টা - রাত ৯টা।
                                        </h6>
                                    </div>
                                </div>

                            </div>
                            <!--End InvoiceBot-->
                        </div>
                        <!--End Invoice-->
                    </div>
                    <div class="modal-footer">
                        <div class="col-md-12">
                            <div class="row button-list pt-2">
                            <div class="col-md-4" style="padding: 0 5px">
                                <div class="d-grid">
                                <button
                                    type="button"
                                    class="btn btn-sm btn-success"
                                    @click="printBillingInvoice('billing-invoice')"
                                >
                                    Print
                                </button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>             

        </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "../../helper/Modal";
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { ref, onMounted } from "vue";
import Form from 'vform'
import axios from 'axios';
export default {
    name: 'Appointments',
    components: {
        Modal,
        Datatable,
        Pagination,
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            isSubmit: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            showModalActive: false,
            errors: {},
            imagePreview: '',
            btn:'Create',
            renderOptionComponent: true,
            billing_items: [],
            billing_info: '',
            loading: true,
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },            
            columns: [ 
                {
                    label: 'SL',
                    name: '',  
                    isSearch: false, 
                    isAction: true,         
                    width: '5%'
                }, 
                {
                    label: 'Date',
                    name: 'date',
                    width: '10%'
                },    
                {
                    label: 'Bill No',
                    name: 'bill_no',
                    width: '10%'
                },    
                {
                    label: 'Patient',
                    name: 'patient_name',
                    width: '15%'
                },
                {
                    label: 'Phone',
                    name: 'patient_phone',
                    width: '10%'
                },
                {
                    label: 'TotalAmount',
                    name: 'payable_amount',
                    width: '10%'
                },
                {
                    label: 'PaidAmount',
                    name: 'paid_amount',
                    width: '10%'
                },
                {
                    label: 'PaymentStatus',
                    name: 'payment_status',
                    width: '7%'
                },
                {
                    label: 'Status',
                    name: 'status',
                    width: '7%'
                },
                {
                    label: 'Actions',            
                    name: '',
                    isSearch: false, 
                    isAction: true,
                    width: '16%',

                }
            ],  
            tableData: {
                draw: 0,
                length: 10,
                search: '',
                column: 2,
                dir: 'asc',
                sortKey: 'bill_no', 
            }, 
            lang: {
                lengthMenu: this.$props.language.lengthMenu ? this.$props.language.lengthMenu : 'Show_MENU_entries',
                info: this.$props.language.info ? this.$props.language.info : 'Showing_FROM_to_TO_of_TOTAL_entries',
                zeroRecords: this.$props.language.zeroRecords ? this.$props.language.zeroRecords : 'No data available in table.', 
                search: this.$props.language.search ? this.$props.language.search : 'Search'
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
                links:[],
            }

        };
    },
    created() { 
        this.getBillingList();
    },
    methods: { 
        forceRerender() {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;
            });
        },

        toggleModal: function() {
            this.modalActive = !this.modalActive;   
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
            this.form.reset();  
        },
         
        invoiceModal: function() {  
            this.showModalActive = !this.showModalActive;
        },

        getPaymentReceive(item) {
            
        },

        printContent(document_id) { 
            const options = {
                name: '_blank',
                specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
                styles: [ 
                    this.baseUrlPrintCSS+'/assets/css/bootstrap-print.min.css',
                    this.baseUrlPrintCSS+'/assets/css/billing_invoice.css'
                ],
            };
            this.$htmlToPaper(document_id, options);
        },

        sendSampleCollection: function(item) { 
            this.$swal({
                title: 'Are you sure?',
                text: "You want send for sample collection!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, send it!'
            }).then((result) => { 
                if (result.value) { 
                    
                    const formData = new FormData();  
                    axios.post(this.apiUrl+'/hm/diagnosis_billings/send-sample-collection/'+item.id, formData, this.headers)
                    .then(res => {
                        if(res.status == 200){  
                            this.getBillingList();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message); 
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            });
        },

        show: function(item) {
            this.billing_info = item;
            this.invoiceModal();
        },

        edit: function(billingId) { 
            // let encodedBillingId = Buffer.from(billingId.toString()).toString('base64');
            let encodedBillingId = this.base64Encode(billingId)+'&&today-list';
            // return `/accounting/receive-payment?billing_id=${billingId}`;
            return `/diagnosis-billings/edit/${encodedBillingId}`;
        },

        validation: function (...fiels){ 
            var obj = new Object(); 
            var validate = false;
            for (var k in fiels){     // Loop through the object  
                for (var j in this.form){  
                    if((j==fiels[k]) && (!this.form[j])) {  
                        obj[fiels[k]] = fiels[k].replace("_", " ")+' field is required';  // Delete obj[key]; 
                        this.errors = {...this.errors, ...obj};
                    }else{
                        validate = false;
                    }
                }              
            }  
            // var obj = new Object();
            // obj[fiels] = fiels.replace("_", " ")+' field is required';  
            // this.errors = {...this.errors, ...obj}; 
        },

        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },

        deleteItem: function(item) {
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this billing!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/hm/diagnosis_billings/'+item.id,this.headerjson)
                    .then(res => {
                        if(res.status == 200){  
                            this.getBillingList();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message); 
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },

        // For Pagination 
        getBillingList(url = this.apiUrl+'/hm/diagnosis_billings/today') {
            this.tableData.draw++;
            axios.get(url, {params:this.tableData,  headers:this.headerparams})
            .then((response) => {
                let data = response.data.data; 
                if(this.tableData.draw = data.draw) {
                    this.billing_items = data.data.data;
                    this.configPagination(data.data);
                }
            })
            .catch(errors => {
                this.$toast.error(errors.response.data.message);
            })
            .finally((fres) => {
                this.loading = false;
            });
        },

        configPagination(data){
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total   = data.total ? data.total : 0;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from ? data.from : 0;
            this.pagination.to = data.to ? data.to : 0;  
            this.pagination.links = data.links;
        },

        sortBy(key,sortable) {
            this.tableData.sortKey = key;
            //this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = sortable; ///this.sortOrders[key] === 1 ? 'asc' : 'desc'; 
            this.getBillingList();
        },
        setPage(data){  
            this.getBillingList(data.url); 
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },

        printBillingInvoice: function (divId) {   
            this.printContent(divId);
        },


    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {}
}
</script>
<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 700px
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}


/** For Invoice modal css */
    .modal-content.scrollbar-width-thin.invoice-modal {
        width: 100%;
        display: block;
        margin: auto;
    }

    .invoice-billing {
        font-family: Verdana, Geneva, Tahoma, sans-serif;
    }

    .invoice-billing #top h2{
        font-size: 18px;
    }

    .invoice-billing #top h5{
        font-size: 14px;
    }

    .invoice-billing #top p{
        font-size: 14px;
    }

    .invoice-billing #mid {
        margin-bottom: 10px;
    }

    #mid .info {
        border: 1px solid #282828;
        padding: 0 10px 5px 10px;
        border-radius: 10px;
        margin-bottom: 10px;
    }

    #mid .info table {
        width: 100%;
    }

    #mid .info table tr td{
        font-size: 14px;
    }

    #mid .info table tr td#pname {
        font-weight: 550;
        font-size: 15px;
        text-transform: uppercase;
    }

    #bot .items-info table thead {
        border: 1px solid #282828;
        font-size: 14px;
    }

    #bot .items-info table thead td{
        padding: 5px 10px;
    }

    #bot .items-info table tbody tr{
        border-bottom: 1px solid #e0e0e0;
    }
    #bot .items-info table tbody td{
        padding: 3px 10px;
        font-size: 14px;
    }

    .corporate-payment-info {
        margin-top: 10px;
    }

    .corporate-info p{
        font-size: 14px;
    }

    .payment-info {
        width: 100%;
        border: none;
    }

    .payment-info tr {
        border-bottom: 0 !important;
    }

    .payment-info tr td{
        padding: 3px 10px;
        font-size: 14px;
        border: 0 !important;
        border-top: 0 !important;
        border-bottom: 0 !important;
    }

    .status-signatures {
        margin-top: 10px;
    }

    .status-info h3 {
        font-size: 18px;
    }

    .status-info h3 span {
        padding: 5px; 
        font-size: 22px;
        border: 1px solid #282828; 
        border-radius: 0px;
    }

    .status-info span {
        font-size: 11px;
    }

    .signature-info {
        text-align: center;
    }
    .signature-info h4 {
        text-align: center;
        font-size: 16px;
        border-bottom: 2px solid #e0e0e0;
        margin-bottom: 5px;
        padding-bottom: 2px;
    }

    .signature-info span {
        font-size: 14px;
        text-align: center;
    }

    .room-info {
        margin-top: 10px;
    }

    .room-info p {
        font-size: 13px;
    }

    .room-info p span {
        padding: 5px 10px;
        font-size: 13px;
        margin-right: 5px;
        border: 1px solid #282828;
        border-radius: 0;
    }

    .legal-info {
        margin-top: 10px;
    }

    .legal-info h6 {
        text-align: center;
        font-size: 13px;
        margin-top: 0;
        margin-bottom: 7px;
    }
</style>